<table>
  <thead>
    <tr>
      <th class="text-gray-500 border-bottom-1 border-gray-500" style="width: 60px">Day</th>
      <th class="text-gray-500 border-bottom-1 border-gray-500" style="width: 60px">Open</th>
      <th class="text-gray-500 border-bottom-1 border-gray-500" style="width: 80px">Opens at</th>
      <th class="text-gray-500 border-bottom-1 border-gray-500" style="width: 80px">Closes at</th>
    </tr>
  </thead>
  <tbody>
    <tr
      customer-sites-opening-times-row
      *ngFor="let item of openingTimesForm.controls"
      [formGroup]="item"
      [disableFields]="disableFields"
    ></tr>
  </tbody>
</table>
<div class="w-full border-top-1 border-gray-500 pt-1" *ngIf="errors.length > 0">
  <div *ngFor="let error of errors" class="pl-2 pb-1 text-danger">{{ error }}</div>
</div>
